import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import { getUserWalletHistory, getWalletHistoryLoaded } from 'domains/user/selectors'
import { useSelector } from 'react-redux'
import getColumns from './columns'
import useAction from 'utils/useAction'
import { fetchWalletHistoryForUser } from 'actions/views/users'

const PAGE_SIZE = 25

const UserWalletHistoryModal = ({ userId, closeModal }) => {
  const walletHistoryData = useSelector(getUserWalletHistory)
  const areWalletHistoryLoaded = useSelector(getWalletHistoryLoaded)
  const fetchWalletHistoryForUserFunc = useAction(fetchWalletHistoryForUser)
  const [currentPage, setCurrentPage] = useState(1)

  const paginationConfig = {
    position: ['bottomCenter'],
    showQuickJumper: true,
    total: walletHistoryData?.page_count * PAGE_SIZE || 0,
    pageSize: PAGE_SIZE,
    current: currentPage,
    showSizeChanger: false,
    onChange: (page) => {
      setCurrentPage(page)
      fetchWalletHistory(page)
    }
  }

  const fetchWalletHistory = (page = 1) => {
    fetchWalletHistoryForUserFunc({ userId, page })
  }

  useEffect(() => {
    if (userId) {
      fetchWalletHistory(1)
    }
  }, [userId])

  // Function to determine row class based on state
  const getRowClassName = (record) => {
    switch (record.state) {
      case 'cancelled':
      case 'expired':
        return 'wallet-history-row-red'
      case 'paid':
        return 'wallet-history-row-green'
      default:
        return ''
    }
  }

  return (
    <div style={{ margin: 16, width: '100%', overflowX: 'hidden' }}>
      {walletHistoryData?.balance !== undefined && (
        <div style={{ marginBottom: 16 }}>
          <strong>User: </strong> {userId} <br/>
          <strong>Current Balance: </strong> {walletHistoryData.balance}
        </div>
      )}
      <div className="table-container" style={{ overflowX: 'auto' }}>
        <Table
          dataSource={walletHistoryData?.history || []}
          columns={getColumns()}
          loading={!areWalletHistoryLoaded}
          pagination={paginationConfig}
          rowKey="id"
          rowClassName={getRowClassName}
          scroll={{ x: 'max-content' }}
          style={{ width: '100%' }}
        />
      </div>
      <style jsx>{`
        .wallet-history-row-red {
          background-color: #ffccc7;
        }
        .wallet-history-row-green {
          background-color: #d9f7be;
        }
      `}</style>
    </div>
  )
}

export default UserWalletHistoryModal
